import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedCompanyType } from '../store/selectors/AuthSelectors';

// Returns Swedish-locale terminology that varies by company type.
//
// Session B ships the hook with one concept: `companyTypeLabel` — the
// canonical Pascal-case ENUM value as the display label. Future sessions
// add concepts (e.g. owner-equity term: "Aktieägare" / "Delägare" /
// "Medlem" / "Stiftare") as their consumers land. Per the project's
// scope discipline, we don't pre-populate concepts without a consumer.
export function useTerminology() {
  const companyType = useSelector(getSelectedCompanyType);

  return useMemo(() => ({
    companyType,
    companyTypeLabel: companyType || '',
  }), [companyType]);
}

export default useTerminology;
